import o,{css as t}from"../../../node_modules/styled-components/dist/styled-components.esm.js";import{StyledButtonBase as e}from"./ButtonBase.styled.js";import{defaultTheme as n}from"../../../theme/index.js";const i=n["theme"],r=o(e)`
  background: #f47535 !important;
  color: #ffffff !important;

  &:before {
    content: '';
    position: absolute;
    width: 0;
    height: 0;
    top: 100%;
    left: 50%;
    border-radius: 50%;
    transform: translateX(-50%) translateY(-25%);
    transition: all 0.5s ease-in-out;
    background-color: #ed3246 !important;
  }

  &:active {
    box-shadow: 0px 0px 0px 4px rgba(243, 105, 56, 0.5);
  }

  &[disabled]:active {
    box-shadow: none;
  }

  &:not([disabled]):hover {
    background-color: #ed3246 !important;
    transition: all 0.1s ease-in-out 0.35s;

    &:before {
      width: 400px;
      height: 400px;
    }
  }

  &[disabled] {
    background-color: #ffe1d6 !important;
    color: #b1b7bf !important;
    pointer-events: none;
  }

  ${({size:o})=>"large"===o?t`
          ${i.mixin.fontButtonM};
          padding: 16px 20px;
          height: 56px;

          > svg {
            width: 20px;
            height: 20px;
          }
        `:t`
          padding: 8px 16px;
          height: 40px;

          > svg {
            width: 20px;
            height: 20px;
          }
        `}

  ${({spinner:o})=>o&&t`
      :disabled {
        background-color: #ffe1d6 !important;
        color: #b1b7bf !important;
      }
    `};
`;export{r as StyledButtonPrimaryTourslet};
